import { useQuery } from '@tanstack/react-query';
import { queryFn } from './queryFn';
import { useNarrativeSlug } from '@/pages/Narrative/hooks';
import type { Narrative } from './types';

export const getQueryKey = (slug: string): [string, string] => [
  'NARRATIVE',
  slug,
];

const defaultNarrative: Narrative = {
  id: '',
  author: {
    id: '',
    name: '',
    role: '',
    slug: '',
    url: '',
    imageUrl: '',
  },
  company: null,
  companyId: '',
  contentBlocks: [],
  coverImageUrl: '',
  title: '',
  updatedAt: '',
  publishedAt: '',
  slug: '',
  status: '',
  valuations: [],
  currencyIso: '',
  visibility: 'public',
  userHoldsPosition: false,
  disclaimer: '',
  companyCanonicalUrl: '',
  voteCount: {
    downvotes: 0,
    upvotes: 0,
  },
};

export const useNarrative = () => {
  const slug = useNarrativeSlug();
  const {
    data = defaultNarrative,
    isLoading,
    error,
  } = useQuery({
    enabled: Boolean(slug),
    queryFn,
    staleTime: 3600000,
    queryKey: getQueryKey(slug),
  });
  return { data, isLoading, error };
};
